module.exports = __webpack_public_path__ + "static/img/img_banner_text.95828bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_banner_text.png
// module id = DYbc
// module chunks = 1